// theme.ts
import { createTheme } from '@mui/material/styles';

const erpNextTheme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#F7F7F7',  // 浅灰色背景
      paper: '#ffffff',
    },
    primary: {
      main: '#282c34', // 蓝色按钮/主色
    },
    text: {
      primary: '#333333',
      secondary: '#555555',
    },
    divider: '#e0e0e0',
  },
  typography: {
    fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&[aria-label="Profile"] .MuiSvgIcon-root': {
            color: '#0f172a !important',
            fontSize: '28px',
          },
          '&[aria-label="Refresh"] .MuiSvgIcon-root': {
            color: '#f5f5f5 !important',
            fontSize: '28px',
          },
        },
      },
    },
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#f0f2f5 !important',
          },
          '&.RaMenuItemLink-active': {
            backgroundColor: '#e3f2fd !important',
          },
          '&.RaMenuItemLink-active:hover': {
            backgroundColor: '#bbdefb !important',
          }
        },
      },
    },
    MuiSvgIcon: {

      styleOverrides: {
        root: {
          color: '#282c34', // 全局图标颜色
          // 当图标有这个 class 时（RA 控制打开状态）
          '&.RaSidebarToggleButton-menuButtonIconOpen': {
            color: '#f5f5f5 !important',
          },

          // 选中特定 data-testid 的图标
          '&[aria-label="Profile"] .MuiSvgIcon-root': {
            color: '#0f172a !important',
            fontSize: '28px',
          },
          '& .RaUserMenu-userButton .MuiSvgIcon-root': {
            color: '#0f172a !important',
          },
          '&[aria-label="Refresh"]': {
            color: '#f5f5f5',     // 你要的颜色
            fontSize: '28px',     // 你想改其他样式也可以
          },

        },

      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#333333',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          minHeight: 56,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          borderRadius: 6,
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff !important',
          borderRadius: 6,
          boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#f0f2f5',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 'bold',
          color: '#444',
          borderBottom: '1px solid #e0e0e0',
        },
        body: {
          borderBottom: '1px solid #f0f0f0',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          '&.RaLoginForm-button': {
            marginTop: '0px',
          },

        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          width: '100%',
          marginBottom: 0,
          backgroundColor: '#ffffff',
          borderRadius: 8,
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#ccc',
            },
            '&:hover fieldset': {
              borderColor: '#1976d2',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1976d2',
              borderWidth: '2px',
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#fff',

        },
        input: {
          paddingLeft: '10px',
          paddingBottom: '0px',
          paddingTop: '0px',
          height: '50px',
          width: '100%',
          lineHeight: '50px',
          boxSizing: 'border-box',

        },

      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#333333', // 全局字体颜色
        },
        noWrap: {
          color: '#333333', // noWrap 版本文字颜色
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',  // 你想要的菜单背景色
          // 这里可以设置其他样式，比如去掉阴影
          boxShadow: 'none',
        },
      },
    },


    // 新增全局样式覆盖
    MuiCssBaseline: {
      styleOverrides: {
        '.custom-text-input .MuiOutlinedInput-input': {
          //paddingTop: '20px !important', // 特定的顶部内边距
          paddingLeft: '10px',
          paddingBottom: '0px',
          paddingTop: '0px',
          height: '50px',
          width: '100%',
          lineHeight: '50px',
          boxSizing: 'border-box',
        },
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        /* 页大小标签（"Rows per page"） */
        selectLabel: {
          marginBottom: '0px',
          // color: '#333333',
          // fontSize: '0.875rem',
        },
        displayedRows: {
          marginBottom: '0px',
          // color: '#333333',
          // fontSize: '0.875rem',
        },


      },
    },
  },
});

export default erpNextTheme;
